import { Code, ConnectError } from '@connectrpc/connect'

export function isGrpcConnectError(error: any): error is ConnectError {
  return error instanceof ConnectError
}
export function isGrpcConnectNotFoundError(error: any): error is ConnectError {
  return error instanceof ConnectError && error.code === Code.NotFound
}
